/**
 * ============================================
 * WISHLIST PRO - Enhanced Wishlist System
 * Works for guests & logged-in users
 * Supports variants, counter, notifications
 * ============================================
 */

(function() {
  'use strict';

  console.log('Wishlist Pro: Initializing...');

  // Configuration
  var CONFIG = {
    storageKey: 'wishlist_pro',
    maxItems: 50,
    animationDuration: 300,
    wishlistPageUrl: '/pages/wunschliste'  // صفحة الـ Wishlist
  };

  // Wishlist State
  var wishlistItems = [];

  // Initialize
  function init() {
    console.log('Wishlist Pro: Running init()');
    loadWishlist();
    bindEvents();
    updateAllButtons();
    updateCounter();
    
    // If on wishlist page, render items
    if (isWishlistPage()) {
      console.log('Wishlist Pro: On wishlist page, rendering...');
      setTimeout(function() {
        renderWishlistPage();
      }, 100);
    }
  }

  // Load wishlist from localStorage
  function loadWishlist() {
    try {
      var stored = localStorage.getItem(CONFIG.storageKey);
      wishlistItems = stored ? JSON.parse(stored) : [];
      console.log('Wishlist Pro: Loaded', wishlistItems.length, 'items');
    } catch (e) {
      wishlistItems = [];
      console.log('Wishlist Pro: No items found');
    }
  }

  // Save wishlist to localStorage
  function saveWishlist() {
    try {
      localStorage.setItem(CONFIG.storageKey, JSON.stringify(wishlistItems));
    } catch (e) {
      console.warn('Could not save wishlist');
    }
  }

  // Check if item is in wishlist
  function isInWishlist(productId, variantId) {
    return wishlistItems.some(function(item) {
      if (variantId) {
        return item.productId == productId && item.variantId == variantId;
      }
      return item.productId == productId;
    });
  }

  // Add item to wishlist
  function addItem(productData) {
    if (wishlistItems.length >= CONFIG.maxItems) {
      showNotification('Wunschliste ist voll (max ' + CONFIG.maxItems + ')', 'error');
      return false;
    }

    // Check if already exists
    var exists = wishlistItems.some(function(item) {
      return item.productId == productData.productId && 
             item.variantId == productData.variantId;
    });

    if (!exists) {
      wishlistItems.push({
        productId: productData.productId,
        variantId: productData.variantId,
        handle: productData.handle,
        title: productData.title,
        price: productData.price,
        comparePrice: productData.comparePrice,
        image: productData.image,
        url: productData.url,
        variantTitle: productData.variantTitle,
        addedAt: new Date().toISOString()
      });
      saveWishlist();
      updateCounter();
      showNotification('Zur Wunschliste hinzugefügt ❤️', 'success');
      return true;
    }
    return false;
  }

  // Remove item from wishlist
  function removeItem(productId, variantId) {
    var initialLength = wishlistItems.length;
    
    wishlistItems = wishlistItems.filter(function(item) {
      if (variantId) {
        return !(item.productId == productId && item.variantId == variantId);
      }
      return item.productId != productId;
    });

    if (wishlistItems.length < initialLength) {
      saveWishlist();
      updateCounter();
      showNotification('Von Wunschliste entfernt', 'info');
      return true;
    }
    return false;
  }

  // Toggle item in wishlist
  function toggleItem(button) {
    var productId = button.getAttribute('data-product-id');
    var variantId = button.getAttribute('data-variant-id') || null;
    var isActive = button.classList.contains('is-active');

    if (isActive) {
      removeItem(productId, variantId);
      button.classList.remove('is-active');
    } else {
      var productData = {
        productId: productId,
        variantId: variantId,
        handle: button.getAttribute('data-handle'),
        title: button.getAttribute('data-title'),
        price: button.getAttribute('data-price'),
        comparePrice: button.getAttribute('data-compare-price'),
        image: button.getAttribute('data-image'),
        url: button.getAttribute('data-url'),
        variantTitle: button.getAttribute('data-variant-title')
      };
      
      if (addItem(productData)) {
        button.classList.add('is-active');
      }
    }

    // Animate heart
    animateButton(button);
  }

  // Animate button
  function animateButton(button) {
    button.classList.add('wishlist-animate');
    setTimeout(function() {
      button.classList.remove('wishlist-animate');
    }, CONFIG.animationDuration);
  }

  // Update all wishlist buttons on page
  function updateAllButtons() {
    var buttons = document.querySelectorAll('[data-wishlist-btn]');
    buttons.forEach(function(button) {
      var productId = button.getAttribute('data-product-id');
      var variantId = button.getAttribute('data-variant-id') || null;
      
      if (isInWishlist(productId, variantId)) {
        button.classList.add('is-active');
      } else {
        button.classList.remove('is-active');
      }
    });
  }

  // Update wishlist counter in header
  function updateCounter() {
    var count = wishlistItems.length;
    
    var counters = document.querySelectorAll('[data-wishlist-count]');
    counters.forEach(function(counter) {
      counter.textContent = count;
      counter.style.display = count > 0 ? 'flex' : 'none';
    });
  }

  // Show notification
  function showNotification(message, type) {
    type = type || 'success';
    
    // Remove existing notification
    var existing = document.querySelector('.wishlist-notification');
    if (existing) existing.remove();

    var notification = document.createElement('div');
    notification.className = 'wishlist-notification wishlist-notification--' + type;
    notification.innerHTML = '<span>' + message + '</span><a href="' + CONFIG.wishlistPageUrl + '" class="wishlist-notification-link">Ansehen →</a>';

    document.body.appendChild(notification);

    // Animate in
    setTimeout(function() {
      notification.classList.add('is-visible');
    }, 10);

    // Remove after 3 seconds
    setTimeout(function() {
      notification.classList.remove('is-visible');
      setTimeout(function() {
        notification.remove();
      }, 300);
    }, 3000);
  }

  // Check if on wishlist page
  function isWishlistPage() {
    var path = window.location.pathname.toLowerCase();
    return path.indexOf('/pages/wunschliste') > -1 || 
           path.indexOf('/pages/wishlist') > -1;
  }

  // Render wishlist page
  function renderWishlistPage() {
    var container = document.querySelector('[data-wishlist-container]');
    if (!container) {
      console.log('Wishlist Pro: Container not found');
      return;
    }

    console.log('Wishlist Pro: Rendering', wishlistItems.length, 'items');

    if (wishlistItems.length === 0) {
      container.innerHTML = '\
        <div class="wishlist-empty">\
          <div class="wishlist-empty-icon">\
            <i class="fa fa-heart-o"></i>\
          </div>\
          <h2>Ihre Wunschliste ist leer</h2>\
          <p>Fügen Sie Produkte hinzu, die Sie später kaufen möchten</p>\
          <a href="/collections/all" class="wishlist-continue-btn">\
            <i class="fa fa-shopping-bag"></i> Weiter einkaufen\
          </a>\
        </div>';
      return;
    }

    var html = '\
      <div class="wishlist-header">\
        <h2>' + wishlistItems.length + ' Artikel in Ihrer Wunschliste</h2>\
        <div class="wishlist-actions">\
          <button class="wishlist-share-btn" data-share-wishlist>\
            <i class="fa fa-share-alt"></i> Teilen\
          </button>\
          <button class="wishlist-add-all-btn" data-add-all-cart>\
            <i class="fa fa-shopping-cart"></i> Alle in den Warenkorb\
          </button>\
          <button class="wishlist-clear-btn" data-clear-wishlist>\
            <i class="fa fa-trash"></i> Alle entfernen\
          </button>\
        </div>\
      </div>\
      <div class="wishlist-grid">';

    wishlistItems.forEach(function(item) {
      var price = parseFloat(item.price) || 0;
      var comparePrice = parseFloat(item.comparePrice) || 0;
      var discount = comparePrice > price ? Math.round((1 - price / comparePrice) * 100) : 0;
      
      var priceFormatted = (price / 100).toFixed(2).replace('.', ',');
      var comparePriceFormatted = (comparePrice / 100).toFixed(2).replace('.', ',');

      html += '\
        <div class="wishlist-item" data-wishlist-item data-product-id="' + item.productId + '">\
          <div class="wishlist-item-image">\
            <a href="' + (item.url || '#') + '">\
              <img src="' + (item.image || '/no-image.png') + '" alt="' + (item.title || 'Product') + '" loading="lazy">\
            </a>\
            ' + (discount > 0 ? '<span class="wishlist-item-badge">-' + discount + '%</span>' : '') + '\
            <button class="wishlist-item-remove" data-remove-item data-product-id="' + item.productId + '" data-variant-id="' + (item.variantId || '') + '">\
              <i class="fa fa-times"></i>\
            </button>\
          </div>\
          <div class="wishlist-item-info">\
            <h3 class="wishlist-item-title">\
              <a href="' + (item.url || '#') + '">' + (item.title || 'Product') + '</a>\
            </h3>\
            ' + (item.variantTitle && item.variantTitle !== 'Default Title' ? '<p class="wishlist-item-variant">' + item.variantTitle + '</p>' : '') + '\
            <div class="wishlist-item-price">\
              <span class="current-price">€' + priceFormatted + '</span>\
              ' + (comparePrice > price ? '<span class="compare-price">€' + comparePriceFormatted + '</span>' : '') + '\
            </div>\
            <button class="wishlist-item-cart" data-add-to-cart data-variant-id="' + (item.variantId || item.productId) + '">\
              <i class="fa fa-shopping-cart"></i> In den Warenkorb\
            </button>\
          </div>\
        </div>';
    });

    html += '</div>';

    // Share Modal
    html += '\
      <div class="wishlist-share-modal" data-share-modal>\
        <div class="wishlist-share-content">\
          <button class="wishlist-share-close" data-close-modal>×</button>\
          <h3>Wunschliste teilen</h3>\
          <div class="wishlist-share-buttons">\
            <a href="#" class="share-btn share-whatsapp" data-share="whatsapp">\
              <i class="fa fa-whatsapp"></i> WhatsApp\
            </a>\
            <a href="#" class="share-btn share-facebook" data-share="facebook">\
              <i class="fa fa-facebook"></i> Facebook\
            </a>\
            <a href="#" class="share-btn share-email" data-share="email">\
              <i class="fa fa-envelope"></i> Email\
            </a>\
            <button class="share-btn share-copy" data-share="copy">\
              <i class="fa fa-copy"></i> Link kopieren\
            </button>\
          </div>\
        </div>\
      </div>';

    container.innerHTML = html;
    bindWishlistPageEvents();
  }

  // Bind wishlist page events
  function bindWishlistPageEvents() {
    // Remove item
    var removeButtons = document.querySelectorAll('[data-remove-item]');
    removeButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var productId = this.getAttribute('data-product-id');
        var variantId = this.getAttribute('data-variant-id') || null;
        removeItem(productId, variantId);
        
        var item = this.closest('[data-wishlist-item]');
        item.style.opacity = '0';
        item.style.transform = 'scale(0.8)';
        setTimeout(function() {
          item.remove();
          if (wishlistItems.length === 0) {
            renderWishlistPage();
          } else {
            // Update header count
            var headerH2 = document.querySelector('.wishlist-header h2');
            if (headerH2) {
              headerH2.textContent = wishlistItems.length + ' Artikel in Ihrer Wunschliste';
            }
          }
        }, 300);
      });
    });

    // Add to cart
    var cartButtons = document.querySelectorAll('[data-add-to-cart]');
    cartButtons.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var variantId = this.getAttribute('data-variant-id');
        addToCart(variantId, this);
      });
    });

    // Add all to cart
    var addAllBtn = document.querySelector('[data-add-all-cart]');
    if (addAllBtn) {
      addAllBtn.addEventListener('click', function() {
        addAllToCart();
      });
    }

    // Clear wishlist
    var clearBtn = document.querySelector('[data-clear-wishlist]');
    if (clearBtn) {
      clearBtn.addEventListener('click', function() {
        if (confirm('Sind Sie sicher, dass Sie alle Artikel entfernen möchten?')) {
          wishlistItems = [];
          saveWishlist();
          updateCounter();
          renderWishlistPage();
        }
      });
    }

    // Share modal
    var shareBtn = document.querySelector('[data-share-wishlist]');
    var shareModal = document.querySelector('[data-share-modal]');
    
    if (shareBtn && shareModal) {
      shareBtn.addEventListener('click', function() {
        shareModal.classList.add('is-visible');
      });
      
      var closeBtn = shareModal.querySelector('[data-close-modal]');
      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          shareModal.classList.remove('is-visible');
        });
      }

      shareModal.addEventListener('click', function(e) {
        if (e.target === shareModal) {
          shareModal.classList.remove('is-visible');
        }
      });

      // Share buttons
      var shareBtns = shareModal.querySelectorAll('[data-share]');
      shareBtns.forEach(function(btn) {
        btn.addEventListener('click', function(e) {
          e.preventDefault();
          var type = this.getAttribute('data-share');
          shareWishlist(type);
        });
      });
    }
  }

  // Add to cart function
  function addToCart(variantId, button) {
    if (!variantId) return;

    button.disabled = true;
    button.innerHTML = '<i class="fa fa-spinner fa-spin"></i> Wird hinzugefügt...';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: parseInt(variantId), quantity: 1 })
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      button.innerHTML = '<i class="fa fa-check"></i> Hinzugefügt!';
      button.classList.add('added');
      updateCartCounter();
      
      setTimeout(function() {
        button.innerHTML = '<i class="fa fa-shopping-cart"></i> In den Warenkorb';
        button.disabled = false;
        button.classList.remove('added');
      }, 2000);
    })
    .catch(function(error) {
      console.error('Cart error:', error);
      button.innerHTML = '<i class="fa fa-exclamation"></i> Fehler';
      setTimeout(function() {
        button.innerHTML = '<i class="fa fa-shopping-cart"></i> In den Warenkorb';
        button.disabled = false;
      }, 2000);
    });
  }

  // Add all to cart
  function addAllToCart() {
    var items = wishlistItems.map(function(item) {
      return {
        id: parseInt(item.variantId || item.productId),
        quantity: 1
      };
    });

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: items })
    })
    .then(function(response) { return response.json(); })
    .then(function(data) {
      showNotification('Alle Artikel wurden zum Warenkorb hinzugefügt!', 'success');
      updateCartCounter();
    })
    .catch(function(error) {
      showNotification('Fehler beim Hinzufügen', 'error');
    });
  }

  // Update cart counter
  function updateCartCounter() {
    fetch('/cart.js')
    .then(function(response) { return response.json(); })
    .then(function(data) {
      var counters = document.querySelectorAll('.cart-quantity, .bigcounter');
      counters.forEach(function(el) {
        el.textContent = data.item_count;
      });
    });
  }

  // Share wishlist
  function shareWishlist(type) {
    var url = window.location.href;
    var text = 'Schau dir meine Wunschliste an: ' + wishlistItems.length + ' Artikel';

    switch(type) {
      case 'whatsapp':
        window.open('https://wa.me/?text=' + encodeURIComponent(text + ' ' + url), '_blank');
        break;
      case 'facebook':
        window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url), '_blank');
        break;
      case 'email':
        window.location.href = 'mailto:?subject=Meine Wunschliste&body=' + encodeURIComponent(text + '\n\n' + url);
        break;
      case 'copy':
        if (navigator.clipboard) {
          navigator.clipboard.writeText(url).then(function() {
            showNotification('Link wurde kopiert!', 'success');
          });
        }
        break;
    }
  }

  // Bind events
  function bindEvents() {
    // Wishlist buttons
    document.addEventListener('click', function(e) {
      var button = e.target.closest('[data-wishlist-btn]');
      if (button) {
        e.preventDefault();
        toggleItem(button);
      }
    });
  }

  // Initialize on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Expose to global scope
  window.WishlistPro = {
    add: addItem,
    remove: removeItem,
    toggle: toggleItem,
    isIn: isInWishlist,
    getItems: function() { return wishlistItems; },
    getCount: function() { return wishlistItems.length; },
    clear: function() {
      wishlistItems = [];
      saveWishlist();
      updateCounter();
      updateAllButtons();
    },
    refresh: function() {
      loadWishlist();
      updateAllButtons();
      updateCounter();
      if (isWishlistPage()) {
        renderWishlistPage();
      }
    }
  };

})();
